<script>
  import { gql } from "@apollo/client/core";
  import { query } from "svelte-apollo";
  import { _ as t } from "svelte-i18n";

  import { applyTheme } from "../theme.js";
  import { client } from "../apollo";

  import { Button } from "t2c-components";
  import LangSwitch from "components/LangSwitch.svelte";
  import Loader from "components/Loader.svelte";

  const ORGANIZATION_CONFIG_QUERY = gql`
    query OrganizationConfigQuery {
      organizationConfig {
        id
        name
        space
        logoHash
        logoWidth
        logoHeight
        theme
        accentColor
        clientBackgroundImage
        acceptedLanguages {
          tag
          quality
        }
      }
    }
  `;

  const organizationConfig = query(client, {
    query: ORGANIZATION_CONFIG_QUERY,
  });

  organizationConfig.result().then((config) => {
    // Configure accent color
    const organizationConfig = config.data.organizationConfig;
    applyTheme(organizationConfig);
  });

  const redirect = (path) => {
    window.location.href = path;
  };

  const handleBackToLogin = () => {
    redirect("/login");
  };
</script>

{#await $organizationConfig}
  <div class="nolawyer">
    <Loader />
  </div>
{:then config}
  <div class="wrapper">
    <div class="modal">
      {#if config.data.organizationConfig.logoHash}
        <div class="logo">
          <img
            src={`/download-file/logo/${config.data.organizationConfig.id}?hash=${config.data.organizationConfig.logoHash}`}
            alt="logo"
          />
        </div>
      {:else}
        <h1 class="title">{config.data.organizationConfig.name}</h1>
      {/if}
      <h1 style="font-weight: 300; margin-bottom: 2rem">
        {$t("login.expired")}
      </h1>
      <p>{$t("login.expiredDesc")}</p>
      <Button style="" on:click={handleBackToLogin}>{$t("login.back")}</Button>
      <LangSwitch />
    </div>
  </div>
{:catch error}
  <p>Error: {error}</p>
{/await}

<style>
  .wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 100vh;
    background-color: #eeeeee;
  }

  .wrapper::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: var(--client-background-image);
    background-size: cover;
    filter: grayscale(100%);
  }

  .modal {
    z-index: 1;
    margin-top: 48px;
    margin: 0 auto;
    max-width: 900px;
    padding: 24px;
    border: 2px solid black;
    background-color: rgba(255, 255, 255, 0.95);
  }

  h1 {
    font-size: 26px;
    font-weight: 400;
    text-transform: uppercase;
    margin-top: 24px;
  }

  p {
    max-width: 30em;
  }

  .logo {
    display: flex;
    justify-content: center;
  }

  .logo img {
    height: 150px;
  }

  .title {
    line-height: 2.5rem;
  }

  .nolawyer {
    text-align: center;
    padding: 50px;
    font-size: 24px;
    letter-spacing: 0.08rem;
  }
</style>
